import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';
import template from './manageUsersView.html';
import Logger from '../../../shared/logger';
import BaseComponent from '../../base/component';
import { Async, Inject } from '../../base/decorators';
import { EMPLOYER_REP_ROLES } from '../employerRep/constants/roles';
import UtilsService from '../../../services/utilsService';
import './style.scss';
import { authEntityTypes } from '../../core/authentication/authenticationService';
import { EmployerRep, EmployerRepService } from '../../core/route/employerRepService';
import { Recruiter } from '../../core/route/recruiterService';
import { templateName } from '../../../services/emailService';
import logger from '../../../shared/logger';

String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export const TALENYA_COMPANY_NAME = 'TALENYA';

export class EmployerManageUsersComponent extends BaseComponent {
    userRolesOptions = [{
        value: EMPLOYER_REP_ROLES.HR,
        label: 'HR',
        description: 'HR_DESCRIPTION',
    }, {
        value: EMPLOYER_REP_ROLES.NON_HR,
        label: 'NON_HR',
        description: 'NON_HR_DESCRIPTION',
    }];

    userTypeOptions = [{
        value: EMPLOYER_REP_ROLES.USER,
        label: 'REGULAR_ACCESS',
        description: 'CAN_ACCESS_EVERYTHING_BUT_CANNOT_CREATE_USERS',
    }, {
        value: EMPLOYER_REP_ROLES.ADMIN,
        label: 'FULL_ACCESS',
        description: 'CAN_ACCESS_EVERYTHING_AND_CREATE_USERS',
    }];

    addUserClicked = false;

    getSenderName = () => {};

    getSenderEmail = () => {};

    @Inject('AuthService') authService;

    @Inject('EmployerRepService') employerRepService;

    @Inject('RecruiterService') recruiterService;

    @Inject('$stateParams') $stateParams;

    @Inject('$uibModal') $uibModal;

    @Inject('RouteService') routeService;

    @Inject('$filter') $filter;

    @Inject('EnvSettings') EnvSettings;

    @Inject('$cookies') $cookies;

    @Inject('$state') $state;

    @Inject('NotificationService') notificationService;

    @Inject('permissions') permissions;

    @Inject('ModalDialogService') modalDialogService;

    async setupComponentData() {
        const language = this.routeService.getUserPreference('uiLanguage') || 'en-US';
        const employerId = this.getEmployerId();
        const promises = [];
        promises.push(this.employerRepService.getEmployersRepSearch({ employerId }));
        const authEntityType = this.authService.getAuthEntityType();
        const authEntityId = this.authService.getCurrentUserEntityId();

        let getSenderNameFunction;
        let getSenderEmailFunction;

        const templateNames = {};
        if (authEntityType === authEntityTypes.EMPLOYER_REP) {
            promises.push(this.routeService.getEmailTemplates(language, 'inviteEmployerRep_BYEMPREP'));
            promises.push(this.employerRepService.getExistingEmployerRep(authEntityId));
            templateNames.invite = templateName.INVITE_TEMPLATE_EMPREP_1;
            templateNames.reinvite = templateName.RE_INVITE_TEMPLATE_EMPREP_1;
            getSenderNameFunction = (sender) => () => EmployerRep.getName(sender);
            getSenderEmailFunction = (sender) => () => EmployerRep.getEmail(sender);
        }

        if (authEntityType === authEntityTypes.RECRUITER) {
            promises.push(this.routeService.getEmailTemplates(language, 'inviteEmployerRep_BYTE'));
            promises.push(this.recruiterService.getRecruiter(authEntityId));
            templateNames.invite = templateName.INVITE_TEMPLATE_TE_1;
            templateNames.reinvite = templateName.RE_INVITE_TEMPLATE_TE_1;
            getSenderNameFunction = (sender) => () => Recruiter.getName(sender);
            getSenderEmailFunction = (sender) => () => Recruiter.getEmail(sender);
        }

        const [
            { result: employerReps },
            { result: { templates } },
            { result: sender },
        ] = await Promise.all(promises);

        this.getSenderName = getSenderNameFunction(sender);
        this.getSenderEmail = getSenderEmailFunction(sender);

        const inviteTempalte = _.find(templates, { name: templateNames.invite });
        const reinviteTempalte = _.find(templates, { name: templateNames.reinvite });

        this.emailTemplates = {
            invite: inviteTempalte,
            reinvite: reinviteTempalte,
        };

        this.employerRepUsers = this.getEmployerRepUsers(employerReps);
    }

    getEmployerId() {
        if (this.employerCtrl.employerData) {
            return this.employerCtrl.employerData._id;
        }

        return this.$stateParams.employerId;
    }

    removeUser(index) {
        if (this.employerRepUsers[index] && this.employerRepUsers[index]._id) {
            if (this.employerRepUsers[index].roles.length > 0) {
                const adminsCount = _.countBy(this.employerRepUsers, (user) => user.roles.length > 0);
                if (adminsCount.true === 1) {
                    this.removeUserDialog = {
                        employerRepIndex: index,
                    };
                    this.openModalDialog(null, 'areYouSure');
                    return;
                }
            }
            this.removeUserAction(index);
        }
    }

    removeUserAction(index) {
        this.employerRepService.updateExistingEmployerRep(this.employerRepUsers[index]._id, {
            removed: true,
        })
            .then(() => {
                this.employerRepUsers.splice(index, 1);
            })
            .catch((error) => Logger.error(error));
    }

    activateUser(index) {
        if (this.employerRepUsers[index] && this.employerRepUsers[index]._id) {
            this.employerRepService.activateExistingEmployerRep(this.employerRepUsers[index]._id, {})
                .then(() => {
                    this.employerRepUsers[index].status = {
                        current: 'active',
                        history: this.employerRepUsers[index].status,
                        timestamp: Date.now(),
                    };
                })
                .catch((error) => Logger.error(error));
        }
    }

    deactivateUser(index) {
        if (this.employerRepUsers[index] && this.employerRepUsers[index]._id) {
            this.employerRepService.deactivateExistingEmployerRep(this.employerRepUsers[index]._id, {})
                .then(() => {
                    this.employerRepUsers[index].status = {
                        current: 'inactive',
                        history: this.employerRepUsers[index].status,
                        timestamp: Date.now(),
                    };
                })
                .catch((error) => Logger.error(error));
        }
    }

    async sendInvitationEmail(employerRepId, employerRepData) {
        const subject = this.emailTemplates.invite.subject.replaceAll('<span field=\'senderName\'></span>', this.getSenderName());
        const link = this.$state.href('employerRep.signUp.details', { employerRepId, isInvitation: true });
        let body = this.emailTemplates.invite.template;

        body = body.replaceAll('<span field=\'employerRepName\'></span>', `<span field='employerRepName'>${employerRepData.name}</span>`);
        body = body.replaceAll('<span field=\'senderName\'></span>', `<span field='senderName'>${this.getSenderName()}</span>`);
        body = body.replaceAll('<span field=\'employerName\'></span>', `<span field='employerName'>${this.getCurrentUserCompanyName()}</span>`);
        body = body.replaceAll('<a class=\'link\'></a>', `<a href='${this.EnvSettings.Auth0RedirectUrl}${link}'>${this.$filter('translate')('LINK_to_EMPLOYER_REP_REG')}</a>`);

        await this.employerRepService.sendInivitationToEmployerRep({
            from: this.getSenderName() || 'info',
            senderEmail: this.getSenderEmail(),
            body,
            to: [employerRepData.email],
            bcc: [this.getSenderEmail()],
            subject,
        });

        this.notificationService.success('EMPLOYER_REP_ADDED');
    }

    resendInvitation(employerRep) {
        let { subject } = this.emailTemplates.reinvite;

        UtilsService.cookiesOverride(this.$cookies);

        const userData = UtilsService.parseJSON(this.$cookies.get('userData'));

        const bccRecipients = [userData?.email].filter(Boolean);
        const link = this.$state.href('employerRep.signUp.details', { employerRepId: employerRep._id, isInvitation: true });

        subject = subject.replaceAll(
            '<span field=\'senderName\'></span>',
            this.getSenderName(),
        );
        let body = this.emailTemplates.reinvite.template;
        body = body.replaceAll(
            '<span field=\'employerRepName\'></span>',
            `<span field='employerRepName'>${employerRep.name}</span>`,
        );
        body = body.replaceAll(
            '<span field=\'senderName\'></span>',
            `<span field='senderName'>${this.getSenderName()}</span>`,
        );
        body = body.replaceAll(
            '<span field=\'employerName\'></span>',
            `<span field='employerName'>${this.getCurrentUserCompanyName()}</span>`,
        );
        body = body.replaceAll(
            '<a class=\'link\'></a>',
            `<a href="${this.EnvSettings.Auth0RedirectUrl}${link}">${this.$filter('translate')('LINK_to_EMPLOYER_REP_REG')}</a>`,
        );

        this.employerRepService.sendInivitationToEmployerRep({
            from: this.getSenderName() || 'info',
            senderEmail: this.getSenderEmail(),
            body,
            to: [employerRep.email],
            bcc: bccRecipients,
            subject,
        })
            .then(() => {
                this.notificationService.success('REINVITATION_SENT');
            })
            .catch((error) => Logger.error(error));
    }

    panelSettingsOpenPopUp(idx) {
        $('#' + `a-settings_${idx}`)
            .find('#' + `settings_${idx}`)
            .show();
        $('#' + `a-settings_${idx}`)
            .next('#' + `settings_${idx}`)
            .show();

        const offset = $('#' + `a-settings_${idx}`)
            .offset();
        const calcYtop = offset.top - 65;
        const calcXLeft = offset.left - 161;

        $('#' + `a-settings_${idx}`)
            .find('#' + `settings_${idx}`)
            .css('top', calcYtop);
        $('#' + `a-settings_${idx}`)
            .next('#' + `settings_${idx}`)
            .css('top', calcYtop);

        $('#' + `a-settings_${idx}`)
            .find('#' + `settings_${idx}`)
            .css('left', calcXLeft);
        $('#' + `a-settings_${idx}`)
            .next('#' + `settings_${idx}`)
            .css('left', calcXLeft);
    }

    openModalDialog(data, template) {
        this.modalDialogData = data;
        $(`.${template}`).modal('show');
    }

    closeModalDialog(template, form) {
        this.modalDialogData = null;

        $(`.${template}`)
            .modal('hide');
        this.userData = {
            name: null,
            email: null,
        };

        if (form) {
            form.$setPristine();
        }

        this.modalErrorMessage = null;
        this.removeUserDialog = null;
    }

    getUserTranslationKey(status) {
        let result = '';
        switch (status) {
            case 'active':
                result = 'EMPLOYER_REP_ACTIVE';
                break;
            case 'inactive':
                result = 'EMPLOYER_REP_INACTIVE';
                break;
            case 'self_service':
                result = 'EMPLOYER_REP_SELF_SERVICE';
                break;
            case 'invited':
                result = 'EMPLOYER_REP_INVITED';
                break;
            case 'pending':
                result = 'EMPLOYER_REP_PENDING';
                break;
        }
        return result;
    }

    getEmployerRepUsers(employerReps) {
        UtilsService.cookiesOverride(this.$cookies);
        const origUserPrefs = UtilsService.parseJSON(this.$cookies.get('origUserPrefs'));
        const currentUserId = _.get(origUserPrefs, 'employerRepId');

        return _.chain(employerReps || [])
            .map((user) => {
                const isAdmin = (user.roles || []).includes('EM_REP_ADMIN');
                const isHR = (user.roles || []).includes('HR');
                const currentUser = currentUserId === user._id;

                return {
                    ...user,
                    adminRole: isAdmin ? EMPLOYER_REP_ROLES.ADMIN : EMPLOYER_REP_ROLES.USER,
                    hrRole: isHR ? EMPLOYER_REP_ROLES.HR : EMPLOYER_REP_ROLES.NON_HR,
                    currentUser,
                };
            })
            .orderBy([(user) => (_.get(user, 'name') || '').toLowerCase()], ['asc'])
            .value();
    }

    initAddUserForm() {
        this.userData = {
            email: '',
            fullName: '',
            hrRole: EMPLOYER_REP_ROLES.HR,
            adminRole: EMPLOYER_REP_ROLES.ADMIN,
            addUserClicked: false,
        };
    }

    async addUser(form) {
        this.addUserClicked = true;

        if (form.$invalid && !this.userData.fullName) {
            this.modalErrorMessage = 'ERROR_ALL_FIELDS_ARE_REQUIRED';
            return;
        }

        const alreadyExistingEmails = (this.employerRepUsers || []).map(({ email }) => email);

        this.userData.email = (this.userData.email || '').toLowerCase();

        if (this.isEmailAlreadyExist(alreadyExistingEmails, this.userData.email)) {
            this.modalErrorMessage = 'ADD_USER_EMAIL_ALREADY_EXIST';
            form.email.$setValidity('', false);
            return;
        }

        if (!UtilsService.isValidEmail(this.userData.email)) {
            this.modalErrorMessage = 'ILLEGAL_EMAIL_ADDRESS';
            form.email.$setValidity('', false);
            return;
        }

        this.createEmployerRep(this.userData);
        this.closeModalDialog('addUserModal', form);
    }

    async editEmployerRep(employerRep) {
        const modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            component: 'editEmployerRepModalCtrl',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                employerRep: () => _.cloneDeep(employerRep),
            },
        });

        modalInstance
            .result
            .then((updatedEmployerRep) => this.employerRepService.updateExistingEmployerRep(employerRep._id, updatedEmployerRep))
            .then(() => {
                this.notificationService.success('DEFAULT_NOTIFICATION_CHANGES_SAVED');
                this.refreshEmployerRepUsers();
            })
            .catch((err) => {
                if (err) {
                    logger.error(err);
                    this.notificationService.error(err.message);
                }
            });
    }

    async createEmployerRep(userData) {
        const employerId = this.getEmployerId();
        const data = {
            name: userData.fullName,
            employerId,
            email: userData.email,
            roles: [userData.hrRole],
            employerReps: this.employerCtrl.employerData.employerReps,
        };

        if (userData.adminRole === EMPLOYER_REP_ROLES.ADMIN) {
            data.roles.push(EMPLOYER_REP_ROLES.ADMIN);
        }

        const { result: newEmpRep } = await this.employerRepService.createEmployersRep(data);
        await this.sendInvitationEmail(newEmpRep._id, data);
        await this.refreshEmployerRepUsers();
    }

    areYouSureSubmit() {
        if (this.removeUserDialog) {
            this.removeUserAction(this.removeUserDialog.employerRepIndex);
        }
        this.closeModalDialog('areYouSure');
    }

    getCurrentUserCompanyName() {
        if (this.permissions.isTalenyaUser()) {
            return TALENYA_COMPANY_NAME;
        }

        return this.employerCtrl.employerData.name;
    }

    setHrRole(role) {
        this.userData.hrRole = role;
    }

    setAdminRole(role) {
        this.userData.adminRole = role;
    }

    onHRRoleChange(user, { value: role }) {
        return this.addUserRole(user, role);
    }

    onAdminRoleChange(user, { value: role }) {
        if (role === EMPLOYER_REP_ROLES.ADMIN) {
            return this.addUserRole(user, EMPLOYER_REP_ROLES.ADMIN);
        }

        const admins = (this.employerRepUsers || []).filter((user) => user.roles.includes(EMPLOYER_REP_ROLES.ADMIN));

        if (admins.length === 1) {
            return this.modalDialogService.showDialog({
                modalDialogId: 'showSkillsEditConfirmation',
                title: 'UPDATE_USER_TYPE',
                body: 'EMPLOYER_REP_UPDATE_USER_TEXT',
                showCancelButton: true,
                showCloseButton: true,
                cancelButtonClass: 'primary-button',
                buttons: [{
                    label: 'UPDATE_USER_YES',
                    className: 'default-button',
                    onClick: () => this.removeUserRole(user, EMPLOYER_REP_ROLES.ADMIN),
                }],
            });
        }

        return this.removeUserRole(user, EMPLOYER_REP_ROLES.ADMIN);
    }

    addUserRole(user, role) {
        return this.updateUserRole(user, { add: [role] });
    }

    removeUserRole(user, role) {
        return this.updateUserRole(user, { remove: [role] });
    }

    @Async()
    async updateUserRole(user, rolesActions) {
        await this.employerRepService.updateEmployerRepRoles(user._id, rolesActions);
        await this.refreshEmployerRepUsers();
    }

    async refreshEmployerRepUsers() {
        const employerId = this.getEmployerId();
        const { result: employerReps } = await this.employerRepService.getEmployersRepSearch({ employerId });

        this.employerRepUsers = this.getEmployerRepUsers(employerReps);
    }

    isEmailAlreadyExist(existingEmails, newEmail) {
        return (existingEmails || []).findIndex((email) => (email || '').toLowerCase() === (newEmail || '').toLowerCase()) !== -1;
    }
}

export const EmployerManageUsersComponentConfiguration = {
    template,
    require: {
        employerCtrl: '^employerComponent',
    },
    controller: EmployerManageUsersComponent,
    controllerAs: 'empManageUsersCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerManageUsersComponent', EmployerManageUsersComponentConfiguration);
